var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-1 gap-2 sm:grid-cols-2"},[_vm._l((_vm.buttons),function(button){return [_c('home-button',{key:button.title,attrs:{"title":button.title,"blueprintid":button.blueprintid,"validate":button.validate}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }